(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bach-hen-in-a-box-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('thp-box-showcase')) {
    customElements.define('thp-box-showcase', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.animate !== 'true' || this.classList.contains('thp-box--seen')) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        if (!('IntersectionObserver' in window)) { this.classList.add('thp-box--seen'); return; }
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            this.classList.add('thp-box--seen');
            this.observer.disconnect();
          }
        }, { threshold:0.15 });
        this.observer.observe(this.querySelector('.thp-box__intro'));
      }
      disconnectedCallback() { if (this.observer) this.observer.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thp-about-rebuilt"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initializeBestie = (root) => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
    root.querySelectorAll('.thpa-original-bestie').forEach((element) => {
      if (element.dataset.revealReady) return;
      element.dataset.revealReady = 'true';
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const picture = element.querySelector('img');
          const reveal = () => element.classList.add('is-writing');
          if (picture && !picture.complete) picture.addEventListener('load', reveal, { once: true });
          else reveal();
          observer.disconnect();
        });
      }, { threshold: 0.45 });
      observer.observe(element);
    });
  };
  initializeBestie(document);
  document.addEventListener('shopify:section:load', (event) => initializeBestie(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
